﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import KWBasketButton from '@/components/kw.basket.button';

export default class KWBasketReference extends TKCustomElementFactory {
    fieldElement?: HTMLSelectElement;
    basketButton?: KWBasketButton;
    projectAttribute: string;

    constructor() {
        super();

        this.fieldElement = this.querySelector('[data-references]') || undefined;
        this.basketButton = this.querySelector('kw-basket-button') || undefined;
        this.projectAttribute = this.getAttribute('data-project-attribute') || 'data-tk-saldocitem.free5';
    }

    connectedCallback(): void {
        if (!this.fieldElement || !this.basketButton) return;
        this.registerInputListener();
        const { value } = this.fieldElement;
        value && this.sendToBasket(value);
    }

    registerInputListener() {
        const onInput = this.handleInput.bind(this);

        this.pushListener({
            event: 'input',
            element: this.fieldElement!,
            action: onInput,
        });
    }

    handleInput(event: InputEvent) {
        const target = event.target as HTMLSelectElement;
        this.sendToBasket(target.value);
    }

    sendToBasket(value: string) {
        this.basketButton?.setAttribute(this.projectAttribute, value);
    }
}